import React from "react";

export interface LeadFormTemplateProps {
  finalTitle?: string;
  finalSubtitle?: string;
  showFormHeader?: boolean;
  salt: string;
  ctaText?: string;
}

export const LeadFormTemplate: React.FC<LeadFormTemplateProps> = ({
  finalTitle,
  finalSubtitle,
  showFormHeader,
  salt,
  ctaText = "Next Step",
}) => {
  return (
    <div id={`${salt}-lead-form-dialog`} className="card">
      <div className="card__body">
        {showFormHeader && (
          <div className="form-cta">
            <div className="header-wrapper">
              <h2 id={`${salt}-title`} className="h3" dangerouslySetInnerHTML={{ __html: finalTitle ?? "" }} />
            </div>
            <p id={`${salt}-intro-text`} dangerouslySetInnerHTML={{ __html: finalSubtitle ?? "" }} />
          </div>
        )}
        <div id={`${salt}-lead-form-progress-bar-mount-point`} />
      </div>
      <div id={`${salt}-lead-form-error-mount-point`} />
      <div className="form-body steps">
        <div data-name="leadForm">
          <div className="lead-form-steps auto-wrapper card__body">
            <div id={`${salt}-lead-form-field-mount-point`} />
          </div>
          <div className="card__footer">
            <button
              className="lead-form-next-step button button--theme-cta button--block"
              id={`${salt}-lead-form-next-action-button`}
            >
              {ctaText}
            </button>
            <div id={`${salt}-lead-form-footer-mount-point`} />
          </div>
        </div>
      </div>
    </div>
  );
};
